<template>
  <v-chip
    v-if="person && !selectOption"
    @click="goToPerson(person)"
    :disabled="person.readonly"
    :small="small"
  >
    <v-avatar v-if="showAvatar" left class="primary">
      <v-img v-if="person.avatar != null" :src="person.avatar"></v-img>
      <span class="button-text white--text" v-else>{{ initials }}</span>
    </v-avatar>
    <v-badge dot inline right :value="person.isSelf">
      {{ person.displayText }}
    </v-badge>
  </v-chip>
  <v-chip v-else-if="person" :small="small" color="transparent">
    <v-avatar v-if="showAvatar" left class="primary">
      <v-img v-if="person.avatar != null" :src="person.avatar"></v-img>
      <span class="button-text white--text" v-else>{{ initials }}</span>
    </v-avatar>
    <v-badge dot inline right :value="person.isSelf">
      {{ person.displayText }}
    </v-badge>
  </v-chip>
  <v-skeleton-loader type="v-chip" v-else> </v-skeleton-loader>
</template>

<script>
export default {
  name: "PersonChip",
  computed: {
    person() {
      return this.id ? this.$store.getters["saved/get"](["people", this.id]) : null;
    },
    initials() {
      var words = this.person.displayText.split(" ");
      var initials = words ? words.map((x) => x[0]) : [];
      return initials.slice(0, 2).join("");
    },
  },
  props: {
    id: {
      type: String,
    },
    small: {
      type: Boolean,
      default: false,
    },
    selectOption: {
      type: Boolean,
      default: false,
    },
    showAvatar: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
